module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/sven-hastedt-avatar-3050563752bba567d0529d167fe106f2.jpg";